import { RecommendationType } from 'store/recommendations/types';

export const findRecommendationForAnalyticRisk = (
  recommendations: RecommendationType[],
  analyticId: number,
  riskLevel: string,
) => recommendations.find((rec) => rec.analytic_id === analyticId && rec.risk_level === riskLevel);
